import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <div className={`mb-6 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] ${light ? "text-[#D99B26]" : "text-[#6E472B]"}`}>
    <span className={`h-px w-10 ${light ? "bg-[#D99B26]" : "bg-[#6E472B]"}`} />
    {children}
  </div>
);

export const Stepper = ({ value, onChange, id, light = false }) => (
  <div className={`inline-flex items-center rounded-full border ${light ? "border-[#F5F0E8]/25 text-[#F5F0E8]" : "border-[#112E23]/20 text-[#112E23]"}`}>
    <button data-testid={`${id}-decrease-button`} aria-label="Decrease" onClick={() => onChange(Math.max(1, value - 1))} className="grid h-10 w-10 place-items-center rounded-full text-lg transition-colors hover:bg-white/10 active:scale-90">−</button>
    <span data-testid={`${id}-value`} className="w-8 text-center font-mono text-sm">{value}</span>
    <button data-testid={`${id}-increase-button`} aria-label="Increase" onClick={() => onChange(Math.min(200, value + 1))} className="grid h-10 w-10 place-items-center rounded-full text-lg transition-colors hover:bg-white/10 active:scale-90">+</button>
  </div>
);
